import React, { useCallback, useMemo, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

import { ReactComponent as CrossIcon } from '../../../assets/images/cross-outlined.svg';
import { ReactComponent as TagIcon } from '../../../assets/images/TagIcon.svg';

import styles from './CustomCreatableMultiSelect.module.scss';

const CustomCreatableMultiSelect = ({
  placeholder,
  disabled = false,
  options,
  isSearchable = false,
  handleOnChange,
  handleRemoveTag,
  isMulti = true,
  showIcon,
  error,
  value,
}) => {
  const [componentIsFocused, setIsFocused] = useState(false);

  const handleFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const colourStyles = useMemo(
    () => ({
      control: (base) => ({
        ...base,
        '&:hover': { borderColor: error ? '#EA5506' : '#BFBFBF' },
        border: error ? '1px solid #EA5506' : '1px solid #BFBFBF',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
      }),
      multiValue: (base) => ({
        ...base,
        border: '1px solid #0FBC71',
        borderRadius: '200px',
        backgroundColor: 'rgba(15, 188, 113, 0.05)',
        color: '#0FBC71',
        padding: '6px 10px',
        fontSize: '12px',
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: '#0FBC71',
      }),
      option: (base) => ({
        ...base,
        color: '#343741',
        fontSize: '14px',
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        color: '#959595',
        fontSize: '14px',
      }),
      input: (base) => ({
        ...base,
        color: '#444444',
        fontSize: '14px',
      }),
    }),
    [error]
  );

  const onCreate = useCallback(
    (toCreate) => {
      const newData = [...value, { value: toCreate, label: toCreate }];
      handleOnChange(newData);
    },
    [value]
  );

  return (
    <div className={styles.container}>
      <span className="blocking-span">
        <CreatableSelect
          styles={colourStyles}
          options={options}
          isMulti={isMulti}
          value={value}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder=""
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
          }}
          formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
          isDisabled={disabled}
          isSearchable={isSearchable}
          onChange={handleOnChange}
          controlShouldRenderValue={false}
          onCreateOption={onCreate}
        />
        <span className={value.length > 0 || componentIsFocused ? styles.floatingLabelFocused : styles.floatingLabel}>
          {placeholder}
        </span>
        {showIcon && (
          <button type="button" className={styles.floatingLabelIcon}>
            <TagIcon />
          </button>
        )}
        {!!value?.length && (
          <div className={styles.selectedOptionsCont}>
            {value.map((option) => (
              <div className={styles.selectedOption} key={option.value}>
                <p className={styles.selectedLabel}>{option.label}</p>
                <CrossIcon className={styles.removeIcon} onClick={() => handleRemoveTag(option.value)} />
              </div>
            ))}
          </div>
        )}
      </span>
    </div>
  );
};

export default CustomCreatableMultiSelect;
